import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const AppInsightErrorRedirect = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/error')
    window.location.reload()
  }, [navigate])

  return null
}

export default AppInsightErrorRedirect
